import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const listItemVariants = cva(["flex items-center gap-2 text-sm font-medium px-4 py-2 outline-none"], {
  variants: {
    hover: {
      true: "cursor-pointer transition-colors duration-200 hover:bg-primary/5",
      false: ""
    },
    active: {
      true: "bg-primary/5 text-primary",
      false: ""
    },
    disabled: {
      true: "opacity-50 hover:bg-transparent cursor-not-allowed",
      false: ""
    }
  },
  defaultVariants: {
    hover: true,
    active: false,
    disabled: false
  }
});
const ListItem = forwardRef((props, ref) => {
  const { children, hover, active, disabled, className, ...rest } = props;
  return /* @__PURE__ */ jsx("li", { ...rest, ref, className: twMerge(listItemVariants({ hover, active, disabled, className })), children });
});
export {
  ListItem as default
};
//# sourceMappingURL=ListItem.js.map
